exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fas-tags[data-v-f963622a] {\n    font-size: 1em;\n}\n.fas[data-count][data-v-f963622a] {\n    position: relative;\n}\n.fas[data-count][data-v-f963622a]:after {\n    position: absolute;\n    top: .1em;\n    left: -.05em;\n    content: attr(data-count);\n    line-height: .7em;\n    color: #fff;\n    text-align: center;\n    min-width: 2em;\n    font: bold .5em sans-serif;\n}\n", ""]);

// exports
